window.slate = window.slate || {};
window.theme = window.theme || {};
// loaded state script
(function(w) {
  w.addEventListener('load', function() {
    var loader = document.querySelector('html.loader');
    if (loader) {
      loader.classList.add('loaded');

      if(jQuery('body').hasClass('template-contact')) {
        let href = window.location.href;
        if(href.indexOf('contact_posted=true') !== -1) {
          jQuery('html, body').animate({scrollTop: 0},500);
        }
      }
    }

  });
}(window));

/***************** GLOBAL *****************/
/**
 * A11y Helpers
 * -----------------------------------------------------------------------------
 * A collection of useful functions that help make your theme more accessible
 * to users with visual impairments.
 *
 *
 * @namespace a11y
 */

slate.a11y = {

  /**
   * For use when focus shifts to a container rather than a link
   * eg for In-page links, after scroll, focus shifts to content area so that
   * next `tab` is where user expects if focusing a link, just $link.focus();
   *
   * @param {JQuery} $element - The element to be acted upon
   */
  pageLinkFocus: function($element) {
    var focusClass = 'js-focus-hidden';

    $element.first()
      .attr('tabIndex', '-1')
      .focus()
      .addClass(focusClass)
      .one('blur', callback);

    function callback() {
      $element.first()
        .removeClass(focusClass)
        .removeAttr('tabindex');
    }
  },

  /**
   * If there's a hash in the url, focus the appropriate element
   */
  focusHash: function() {
    var hash = window.location.hash;

    // is there a hash in the url? is it an element on the page?
    if (hash && document.getElementById(hash.slice(1))) {
      this.pageLinkFocus($(hash));
    }
  },

  /**
   * When an in-page (url w/hash) link is clicked, focus the appropriate element
   */
  bindInPageLinks: function() {
    $('a[href*=#]').on('click', function(evt) {
      this.pageLinkFocus($(evt.currentTarget.hash));
    }.bind(this));
  },

  /**
   * Traps the focus in a particular container
   *
   * @param {object} options - Options to be used
   * @param {jQuery} options.$container - Container to trap focus within
   * @param {jQuery} options.$elementToFocus - Element to be focused when focus leaves container
   * @param {string} options.namespace - Namespace used for new focus event handler
   */
  trapFocus: function(options) {
    var eventName = options.namespace
      ? 'focusin.' + options.namespace
      : 'focusin';

    if (!options.$elementToFocus) {
      options.$elementToFocus = options.$container;
    }

    options.$container.attr('tabindex', '-1');
    options.$elementToFocus.focus();

    $(document).on(eventName, function(evt) {
      if (options.$container[0] !== evt.target && !options.$container.has(evt.target).length) {
        options.$container.focus();
      }
    });
  },

  /**
   * Removes the trap of focus in a particular container
   *
   * @param {object} options - Options to be used
   * @param {jQuery} options.$container - Container to trap focus within
   * @param {string} options.namespace - Namespace used for new focus event handler
   */
  removeTrapFocus: function(options) {
    var eventName = options.namespace
      ? 'focusin.' + options.namespace
      : 'focusin';

    if (options.$container && options.$container.length) {
      options.$container.removeAttr('tabindex');
    }

    $(document).off(eventName);
  }
};

/**
 * Cart Template Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Cart template.
 *
 * @namespace cart
 */

slate.cart = {
  
  /**
   * Browser cookies are required to use the cart. This function checks if
   * cookies are enabled in the browser.
   */
  cookiesEnabled: function() {
    var cookieEnabled = navigator.cookieEnabled;

    if (!cookieEnabled){
      document.cookie = 'testcookie';
      cookieEnabled = (document.cookie.indexOf('testcookie') !== -1);
    }
    return cookieEnabled;
  }
};

/**
 * Utility helpers
 * -----------------------------------------------------------------------------
 * A collection of useful functions for dealing with arrays and objects
 *
 * @namespace utils
 */

slate.utils = {

  /**
   * Return an object from an array of objects that matches the provided key and value
   *
   * @param {array} array - Array of objects
   * @param {string} key - Key to match the value against
   * @param {string} value - Value to get match of
   */
  findInstance: function(array, key, value) {
    for (var i = 0; i < array.length; i++) {
      if (array[i][key] === value) {
        return array[i];
      }
    }
  },

  /**
   * Remove an object from an array of objects by matching the provided key and value
   *
   * @param {array} array - Array of objects
   * @param {string} key - Key to match the value against
   * @param {string} value - Value to get match of
   */
  removeInstance: function(array, key, value) {
    var i = array.length;
    while(i--) {
      if (array[i][key] === value) {
        array.splice(i, 1);
        break;
      }
    }

    return array;
  },

  /**
   * _.compact from lodash
   * Remove empty/false items from array
   * Source: https://github.com/lodash/lodash/blob/master/compact.js
   *
   * @param {array} array
   */
  compact: function(array) {
    var index = -1;
    var length = array == null ? 0 : array.length;
    var resIndex = 0;
    var result = [];

    while (++index < length) {
      var value = array[index];
      if (value) {
        result[resIndex++] = value;
      }
    }
    return result;
  },

  /**
   * _.defaultTo from lodash
   * Checks `value` to determine whether a default value should be returned in
   * its place. The `defaultValue` is returned if `value` is `NaN`, `null`,
   * or `undefined`.
   * Source: https://github.com/lodash/lodash/blob/master/defaultTo.js
   *
   * @param {*} value - Value to check
   * @param {*} defaultValue - Default value
   * @returns {*} - Returns the resolved value
   */
  defaultTo: function(value, defaultValue) {
    return (value == null || value !== value) ? defaultValue : value
  }
};

/**
 * Rich Text Editor
 * -----------------------------------------------------------------------------
 * Wrap iframes and tables in div tags to force responsive/scrollable layout.
 *
 * @namespace rte
 */

slate.rte = {
  /**
   * Wrap tables in a container div to make them scrollable when needed
   *
   * @param {object} options - Options to be used
   * @param {jquery} options.$tables - jquery object(s) of the table(s) to wrap
   * @param {string} options.tableWrapperClass - table wrapper class name
   */
  wrapTable: function(options) {
    var tableWrapperClass = typeof options.tableWrapperClass === "undefined" ? '' : options.tableWrapperClass;

    options.$tables.wrap('<div class="' + tableWrapperClass + '"></div>');
  },

  /**
   * Wrap iframes in a container div to make them responsive
   *
   * @param {object} options - Options to be used
   * @param {jquery} options.$iframes - jquery object(s) of the iframe(s) to wrap
   * @param {string} options.iframeWrapperClass - class name used on the wrapping div
   */
  wrapIframe: function(options) {
    var iframeWrapperClass = typeof options.iframeWrapperClass === "undefined" ? '' : options.iframeWrapperClass;

    options.$iframes.each(function() {
      // Add wrapper to make video responsive
      $(this).wrap('<div class="' + iframeWrapperClass + '"></div>');

      // Re-set the src attribute on each iframe after page load
      // for Chrome's "incorrect iFrame content on 'back'" bug.
      // https://code.google.com/p/chromium/issues/detail?id=395791
      // Need to specifically target video and admin bar
      this.src = this.src;
    });
  }
};

slate.Sections = function Sections() {
  this.constructors = {};
  this.instances = [];

  $(document)
    .on('shopify:section:load', this._onSectionLoad.bind(this))
    .on('shopify:section:unload', this._onSectionUnload.bind(this))
    .on('shopify:section:select', this._onSelect.bind(this))
    .on('shopify:section:deselect', this._onDeselect.bind(this))
    .on('shopify:section:reorder', this._onReorder.bind(this))
    .on('shopify:block:select', this._onBlockSelect.bind(this))
    .on('shopify:block:deselect', this._onBlockDeselect.bind(this));
};

slate.Sections.prototype = $.extend({}, slate.Sections.prototype, {
  _createInstance: function(container, constructor) {
    var $container = $(container);
    var id = $container.attr('data-section-id');
    var type = $container.attr('data-section-type');

    constructor = constructor || this.constructors[type];

    if (typeof constructor === 'undefined') {
      return;
    }

    var instance = $.extend(new constructor(container), {
      id: id,
      type: type,
      container: container
    });

    this.instances.push(instance);
  },

  _onSectionLoad: function(evt) {
    var container = $('[data-section-id]', evt.target)[0];
    if (container) {
      this._createInstance(container);
    }
  },

  _onSectionUnload: function(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (!instance) {
      return;
    }

    if (typeof instance.onUnload === 'function') {
      instance.onUnload(evt);
    }

    this.instances = slate.utils.removeInstance(this.instances, 'id', evt.detail.sectionId);
  },

  _onSelect: function(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (instance && typeof instance.onSelect === 'function') {
      instance.onSelect(evt);
    }
  },

  _onDeselect: function(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (instance && typeof instance.onDeselect === 'function') {
      instance.onDeselect(evt);
    }
  },

  _onReorder: function(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (instance && typeof instance.onReorder === 'function') {
      instance.onReorder(evt);
    }
  },

  _onBlockSelect: function(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (instance && typeof instance.onBlockSelect === 'function') {
      instance.onBlockSelect(evt);
    }
  },

  _onBlockDeselect: function(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (instance && typeof instance.onBlockDeselect === 'function') {
      instance.onBlockDeselect(evt);
    }
  },

  register: function(type, constructor) {
    this.constructors[type] = constructor;

    $('[data-section-type=' + type + ']').each(function(index, container) {
      this._createInstance(container, constructor);
    }.bind(this));
  }
});

/**
 * Currency Helpers
 * -----------------------------------------------------------------------------
 * A collection of useful functions that help with currency formatting
 *
 * Current contents
 * - formatMoney - Takes an amount in cents and returns it as a formatted dollar value.
 *
 */

slate.Currency = (function () {
  var moneyFormat = '${{amount}}';

  /**
   * Format money values based on your shop currency settings
   * @param  {Number|string} cents - value in cents or dollar amount e.g. 300 cents
   * or 3.00 dollars
   * @param  {String} format - shop money_format setting
   * @return {String} value - formatted value
   */
  function formatMoney(cents, format) {
    if (typeof cents === 'string') {
      cents = cents.replace('.', '');
    }
    var value = '';
    var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    var formatString = (format || moneyFormat);

    function formatWithDelimiters(number, precision, thousands, decimal) {
      precision = slate.utils.defaultTo(precision, 2);
      thousands = slate.utils.defaultTo(thousands, ',');
      decimal = slate.utils.defaultTo(decimal, '.');

      if (isNaN(number) || number == null) {
        return 0;
      }

      number = (number / 100.0).toFixed(precision);

      var parts = number.split('.');
      var dollarsAmount = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      var centsAmount = parts[1] ? (decimal + parts[1]) : '';

      return dollarsAmount + centsAmount;
    }

    switch (formatString.match(placeholderRegex)[1]) {
      case 'amount':
        value = formatWithDelimiters(cents, 2);
        break;
      case 'amount_no_decimals':
        value = formatWithDelimiters(cents, 0);
        break;
      case 'amount_with_comma_separator':
        value = formatWithDelimiters(cents, 2, '.', ',');
        break;
      case 'amount_no_decimals_with_comma_separator':
        value = formatWithDelimiters(cents, 0, '.', ',');
        break;
    }

    return formatString.replace(placeholderRegex, value);
  }

  return {
    formatMoney: formatMoney
  };
})();

/**
 * Image Helper Functions
 * -----------------------------------------------------------------------------
 * A collection of functions that help with basic image operations.
 *
 */

slate.Image = (function() {

  /**
   * Preloads an image in memory and uses the browsers cache to store it until needed.
   *
   * @param {Array} images - A list of image urls
   * @param {String} size - A shopify image size attribute
   */

  function preload(images, size) {
    if (typeof images === 'string') {
      images = [images];
    }

    for (var i = 0; i < images.length; i++) {
      var image = images[i];
      this.loadImage(this.getSizedImageUrl(image, size));
    }
  }

  /**
   * Loads and caches an image in the browsers cache.
   * @param {string} path - An image url
   */
  function loadImage(path) {
    new Image().src = path;
  }

  /**
   * Find the Shopify image attribute size
   *
   * @param {string} src
   * @returns {null}
   */
  function imageSize(src) {
    var match = src.match(/.+_((?:pico|icon|thumb|small|compact|medium|large|grande)|\d{1,4}x\d{0,4}|x\d{1,4})[_\.@]/);

    if (match) {
      return match[1];
    } else {
      return null;
    }
  }

  /**
   * Adds a Shopify size attribute to a URL
   *
   * @param src
   * @param size
   * @returns {*}
   */
  function getSizedImageUrl(src, size) {
    if (size === null) {
      return src;
    }

    if (size === 'master') {
      return this.removeProtocol(src);
    }

    var match = src.match(/\.(jpg|jpeg|gif|png|bmp|bitmap|tiff|tif)(\?v=\d+)?$/i);

    if (match) {
      var prefix = src.split(match[0]);
      var suffix = match[0];

      return this.removeProtocol(prefix[0] + '_' + size + suffix);
    } else {
      return null;
    }
  }

  function removeProtocol(path) {
    return path.replace(/http(s)?:/, '');
  }

  return {
    preload: preload,
    loadImage: loadImage,
    imageSize: imageSize,
    getSizedImageUrl: getSizedImageUrl,
    removeProtocol: removeProtocol
  };
})();

/**
 * Variant Selection scripts
 * ------------------------------------------------------------------------------
 *
 * Handles change events from the variant inputs in any `cart/add` forms that may
 * exist. Also updates the master select and triggers updates when the variants
 * price or image changes.
 *
 * @namespace variants
 */

 slate.Variants = (function() {

  /**
   * Variant constructor
   *
   * @param {object} options - Settings from `product.js`
   */
  function Variants(options) {
    this.$container = options.$container;
    this.product = options.product;
    this.singleOptionSelector = options.singleOptionSelector;
    this.originalSelectorId = options.originalSelectorId;
    this.enableHistoryState = options.enableHistoryState;
    this.currentVariant = this._getVariantFromOptions();

    var params = {
      $container: this.$container,
      product: options.product,
      singleOptionSelector: options.singleOptionSelector,
      originalSelectorId: options.originalSelectorId,
      currentVariant: this.currentVariant,
    };

    this.swatches = new slate.Swatches(params);

    $(this.singleOptionSelector, this.$container).on('change', this._onSelectChange.bind(this));
    setTimeout(() => {
      this._onSelectChange()
    }, 100);
  }

  Variants.prototype = $.extend({}, Variants.prototype, {

    /**
     * Get the currently selected options from add-to-cart form. Works with all
     * form input elements.
     *
     * @return {array} options - Values of currently selected variants
     */
    _getCurrentOptions: function() {
      var currentOptions = $.map($(this.singleOptionSelector, this.$container), function(element) {
        var $element = $(element);
        var type = $element.attr('type');
        var currentOption = {};

        if (type === 'radio' || type === 'checkbox') {
          if ($element[0].checked) {
            currentOption.value = $element.val();
            currentOption.index = $element.data('index');

            return currentOption;
          } else {
            return false;
          }
        } else {
          currentOption.value = $element.val();
          currentOption.index = $element.data('index');

          return currentOption;
        }
      });

      // remove any unchecked input values if using radio buttons or checkboxes
      currentOptions = slate.utils.compact(currentOptions);

      return currentOptions;
    },

    /**
     * Find variant based on selected values.
     *
     * @param  {array} selectedValues - Values of variant inputs
     * @return {object || undefined} found - Variant object from product.variants
     */
    _getVariantFromOptions: function() {
      var selectedValues = this._getCurrentOptions();
      var variants = this.product.variants;
      var found = false;

      variants.forEach(function(variant) {
        var satisfied = true;

        selectedValues.forEach(function(option) {
          if (satisfied) {
            satisfied = (option.value === variant[option.index]);
          }
        });

        if (satisfied) {
          found = variant;
          // $(['data-variant-image'] == variant.id).trigger('click')
        }
      });

      return found || null;
    },

    /**
     * Event handler for when a variant input changes.
     */
    _onSelectChange: function() {
      var variant = this._getVariantFromOptions();

      this.$container.trigger({
        type: 'variantChange',
        variant: variant
      });

      if (!variant) {
        return;
      }

      this._updateMasterSelect(variant);
      this._updateImages(variant);
      this._updatePrice(variant);
      this.currentVariant = variant;

      if (this.enableHistoryState) {
        this._updateHistoryState(variant);
      }
    },

    /**
     * Trigger event when variant image changes
     *
     * @param  {object} variant - Currently selected variant
     * @return {event}  variantImageChange
     */
    _updateImages: function(variant) {
      var variantImage = variant.featured_image || {};
      var currentVariantImage = this.currentVariant.featured_image || {};

      if (!variant.featured_image || variantImage.src === currentVariantImage.src) {
        return;
      }

      this.$container.trigger({
        type: 'variantImageChange',
        variant: variant
      });
    },

    /**
     * Trigger event when variant price changes.
     *
     * @param  {object} variant - Currently selected variant
     * @return {event} variantPriceChange
     */
    _updatePrice: function(variant) {
      if (variant.price === this.currentVariant.price && variant.compare_at_price === this.currentVariant.compare_at_price) {
        return;
      }

      this.$container.trigger({
        type: 'variantPriceChange',
        variant: variant
      });
    },

    /**
     * Update history state for product deeplinking
     *
     * @param {object} variant - Currently selected variant
     */
    _updateHistoryState: function(variant) {
      if (!history.replaceState || !variant) {
        return;
      }

      var newurl = window.location.protocol + '//' + window.location.host + window.location.pathname + '?variant=' + variant.id;
      window.history.replaceState({path: newurl}, '', newurl);
    },

    /**
     * Update hidden master select of variant change
     *
     * @param {object} variant - Currently selected variant
     */
    _updateMasterSelect: function(variant) {
      $(this.originalSelectorId, this.$container)[0].value = variant.id;
    }
  });

  return Variants;
})();

/**
 * Swatches Selection scripts
 * ------------------------------------------------------------------------------
 *
 * Handles change events from the swatches inputs in any `cart/add` forms that may
 * exist.
 *
 * @namespace swatches
 */

slate.Swatches = (function() {

  var selectors = {
    swatches: '[data-swatch]',
    swatchOptions: '[data-swatch-option]',
  };

  /**
   * Swatches constructor
   *
   * @param {object} options - Settings from `variants.js`
   */
  function Swatches(params) {
    this.$container = params.$container;
    this.product = params.product;
    this.currentVariant = params.currentVariant;
    this.singleOptionSelector = params.singleOptionSelector;
    this.originalSelectorId = params.originalSelectorId;
    this.variants = this.product.variants;
    this.options = this.product.options;
    this.swatches = $(selectors.swatches);
    this.swatchOptions = this.swatches.find(selectors.swatchOptions);
    this.colorOptionIndex = this.getOptionIndex('color');
    this.sizeOptionIndex = this.getOptionIndex('size');

    this.hideSwatchesSelects();

    this.defineAvailableColors();

    this.updateVariantMax(this.currentVariant);


    let self = this;

    if (this.colorOptionIndex >= 0) {
      let $filterableSwatches = this.swatches.filter(function(index) {
        return $(self.swatches[index]).data('option-index') != self.colorOptionIndex;
      });
      this.showAvailableOptions(this, $filterableSwatches, this.currentVariant.options[this.colorOptionIndex]);
    } else {
      // this.showAvailableOptions(this, this.swatches);
      this.showAvailableOptions(this, this.swatchOptions);
    }

    $(this.swatchOptions, this.$container).on('change', function(){
      let evt = $(this);
      self.switchSwatches.bind(self)(evt);
    });

    $(this.swatchOptions, this.$container).parent().change(function() {
      let $option = $(this).find(selectors.swatchOptions);

      if ($option.data('swatch-option') == self.colorOptionIndex && self.currentVariant !== undefined) {
        let $swatchHolder = $option.closest(selectors.swatches);

        $swatchHolder.find('.header > span').text(self.currentVariant.options[self.colorOptionIndex]);
      }

      let pdpContainer = $(".pdp-form");
      let $swatchHolders = pdpContainer.find('.header > span');
      let $checkedSwatches = [ ...pdpContainer.find(".swatch-element input:checked") ];

      $.each($swatchHolders, function(i,el){
        $(el).text($($checkedSwatches[i]).attr('value'));
      });
    });
  }

  Swatches.prototype = $.extend({}, Swatches.prototype, {

    hideSwatchesSelects: function() {
      let self = this;

      this.swatches.each(function() {
        let $swatch = $(this);
        $(self.singleOptionSelector).eq(self.getOptionIndex($swatch.data('swatch'))).parent().hide();
      });


    },

    /**
     * Show only av
     *
     * @param {object} variant - Currently selected variant
     */
    defineAvailableColors: function() {
      let self = this;

      if (this.colorOptionIndex >= 0) {
        $.each(this.variants, function(i, variant) {
          if (variant.available) {
            try {
              console.log('-------- COLOR: ', `#swatch-${self.colorOptionIndex}-${variant.options[self.colorOptionIndex].toLowerCase()}`)
              let $option = self.swatchOptions.filter(`#swatch-${self.colorOptionIndex}-${variant.options[self.colorOptionIndex].toLowerCase()}`);
              self.makeSwatchOptionAvailable($option);
            } catch {}
          }
        });
      }
    },

    makeSwatchOptionAvailable: function($option) {
      $option.parent().addClass('available').removeClass('soldout');

      return $option;
    },

    makeSwatchOptionUnavailable: function($option) {
      $option.prop('checked', false).parent().addClass('soldout').removeClass('available');

      return $option;
    },

    getOptionIndex: function(optionName) {
      return this.options.map(v => v.toLowerCase()).indexOf(optionName.toLowerCase());
    },

    getVariantLabels: function(variant) {
      const badgesLists = document.querySelectorAll('.product-badges');
      if(!badgesLists) {
        return;
      }

      badgesLists.forEach((badgesList) => {
        const variantId = badgesList.getAttribute('data-variant-id');

        badgesList.classList.add('hide');
        if(variantId == variant.id) {
          badgesList.classList.remove('hide');
        }
      })
    },

    updateVariantMax: function(variant) {
      const variantQtyMax = jQuery('[data-product-select]').find('[data-variant-qty]:selected').attr('data-variant-qty');
      const variantPolicy = jQuery('[data-product-select]').find('[data-variant-policy]:selected').attr('data-variant-policy');
      const productQty = document.querySelector('.product-qty-input');
      const productQtyVal = productQty.value;

      if ( variantPolicy == 'continue' ) {
        jQuery(productQty).removeAttr('max');
      } else {
        jQuery(productQty).attr('max', variantQtyMax);
        if (productQtyVal > variantQtyMax) {
          jQuery(productQty).attr('value', variantQtyMax);
          jQuery(productQty).val(variantQtyMax);
        }
        setTimeout(jcf.destroyAll(), 100);
        setTimeout(jcf.replaceAll(), 100);
      }
    },

    switchSwatches: function($option) {
      let self = this;
      let swatchIndex = $option.data('swatch-option');
      let $optionSelector = $(this.singleOptionSelector).eq(swatchIndex);
      let optionVal = $option.val();


      if ($optionSelector.val() !== optionVal) {
        let $otherSwatches = this.swatches.filter(function(index) {
          return $(self.swatches[index]).data('option-index') != swatchIndex;
        });
        if (swatchIndex != this.colorOptionIndex) {
          let $swatchesWithoutColor = this.swatches.filter(function(index) {
            return $(self.swatches[index]).data('option-index') != self.colorOptionIndex;
          });
          $otherSwatches = $otherSwatches.filter(value => !$swatchesWithoutColor.has(value));
        }

        if ($otherSwatches.length > 0) {
          this.showAvailableOptions(self, $otherSwatches, optionVal, 'switch');
        }

        $optionSelector.val(optionVal);
      }

      $(this.singleOptionSelector).first().trigger('change');
      this.currentVariant = self.variants.filter(function(v) {return v.id == $(self.originalSelectorId).val();})[0];
    },

    showAvailableOptions: function(self, $swatches, optionVal = '', type = 'load') {
      self.makeSwatchOptionUnavailable($swatches.find(selectors.swatchOptions));

      let hasChecked = false;

      $.each(self.variants, function(i, variant) {
        if (self.colorOptionIndex >= 0) {
          if (((variant.options[self.colorOptionIndex] == optionVal) || (optionVal.length === 0 && variant.options[0] == self.currentVariant.options[0])) && variant.available) {
            $.each($swatches, function(i, swatch) {
              let $swatch = $(swatch);
              let currentSwatchIndex = $swatch.data('option-index');
              let $optionSelector = $(self.singleOptionSelector).eq(currentSwatchIndex);
              let $option = $('[data-value="'+variant.options[currentSwatchIndex]+'"]').find(selectors.swatchOptions).first();

              self.makeSwatchOptionAvailable($option);
              if (type == 'load') {

                if (self.currentVariant.options[currentSwatchIndex] == variant.options[currentSwatchIndex]) {
                  $option.prop('checked', true);
                  $optionSelector.val(variant.options[currentSwatchIndex]);
                }
              } else {
                if (self.currentVariant){
                  if (self.currentVariant.options[currentSwatchIndex] == variant.options[currentSwatchIndex]) {
                    $option.prop('checked', true);
                    $optionSelector.val(variant.options[currentSwatchIndex]);
                  }else if (!hasChecked) {
                    $option.prop('checked', true);
                    $optionSelector.val(variant.options[currentSwatchIndex]);
                  }
                }else if (!hasChecked) {
                  $option.prop('checked', true);
                  $optionSelector.val(variant.options[currentSwatchIndex]);
                }
                hasChecked = true;
              }
            });
          }
        } else {
          $.each($swatches, function(i, swatch) {
            let $swatch = $(swatch);
            let currentSwatchIndex = $swatch.data('option-index');
            let $optionSelector = $(self.singleOptionSelector).eq(currentSwatchIndex);
            let $option = $('[data-value="'+variant.options[currentSwatchIndex]+'"]').find(selectors.swatchOptions).first().trigger('click');
            let $swatchHolder = $option.closest(selectors.swatches);

        $swatchHolder.find('.header > span').text($option.val());

            self.makeSwatchOptionAvailable($option);

          });
        }
      });
    },

  });

  return Swatches;
})();


/***************** TEMPLATES *****************/
/**
 * Customer Addresses Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Customer Addresses
 * template.
 *
 * @namespace customerAddresses
 */

theme.customerAddresses = (function() {
  var $newAddressForm = $('#AddressNewForm');

  if (!$newAddressForm.length) {
    return;
  }

  // Initialize observers on address selectors, defined in shopify_common.js
  if (Shopify) {
    new Shopify.CountryProvinceSelector('AddressCountryNew', 'AddressProvinceNew', {
      hideElement: 'AddressProvinceContainerNew'
    });
  }

  // Initialize each edit form's country/province selector
  $('.address-country-option').each(function() {
    var formId = $(this).data('form-id');
    var countrySelector = 'AddressCountry_' + formId;
    var provinceSelector = 'AddressProvince_' + formId;
    var containerSelector = 'AddressProvinceContainer_' + formId;

    new Shopify.CountryProvinceSelector(countrySelector, provinceSelector, {
      hideElement: containerSelector
    });
  });

  // Toggle new/edit address forms
  $('.address-new-toggle').on('click', function() {
    $newAddressForm.toggleClass('hide');
    $('.address-list__item').toggleClass('hide');
    $('.btn--new-address').toggleClass('hide');
    $('.account-page__greeting-title').toggleClass('hide');
    $('.js-address-mobile-link').toggleClass('hide');
    $('.js-address-mobile-link--alt').toggleClass('hide');
    $('.pagination').toggleClass('hide');
    $('html, body').animate({scrollTop: 0},500);
  });

  $('.address-edit-toggle').on('click', function(e) {
    e.preventDefault();
    var formId = $(this).data('form-id');
    $('#EditAddress_' + formId).toggleClass('hide');
    $('.address-list__item').toggleClass('hide');
    $('.address-new-toggle').toggleClass('hide');
    $('.account-page__greeting-title').toggleClass('hide');
    $('.js-address-mobile-link').toggleClass('hide');
    $('.js-address-mobile-link--alt').toggleClass('hide');
    $('.pagination').toggleClass('hide');
    $('html, body').animate({scrollTop: 0},500);
  });

  $('.js-address-mobile-link--alt').on('click', function(e) {
    e.preventDefault();
    $newAddressForm.addClass('hide');
    $('.js-edit-form').each( function() {
      $(this).addClass('hide')
    })
    $('.address-list__item').removeClass('hide');
    $('.btn--new-address').removeClass('hide');
    $('.account-page__greeting-title').removeClass('hide');
    $('.js-address-mobile-link').removeClass('hide');
    $('.address-new-toggle').removeClass('hide');
    $('.pagination').removeClass('hide');
    $(this).addClass('hide');

  });

  $('.address-delete').on('click', function() {
    var $el = $(this);
    var formId = $el.data('form-id');
    var confirmMessage = $el.data('confirm-message');
    if (confirm(confirmMessage || 'Are you sure you wish to delete this address?')) {
      Shopify.postLink('/account/addresses/' + formId, {parameters: {_method: 'delete'}});
    }
  });
})();

/**
 * Password Template Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Password template.
 *
 * @namespace password
 */

theme.customerLogin = (function() {
  var config = {
    recoverPasswordForm: '#RecoverPassword',
    hideRecoverPasswordLink: '#HideRecoverPasswordLink'
  };

  if (!$(config.recoverPasswordForm).length) {
    return;
  }

  checkUrlHash();
  resetPasswordSuccess();

  $(config.recoverPasswordForm).on('click', onShowHidePasswordForm);
  $(config.hideRecoverPasswordLink).on('click', onShowHidePasswordForm);

  function onShowHidePasswordForm(evt) {
    evt.preventDefault();
    toggleRecoverPasswordForm();
  }

  function checkUrlHash() {
    var hash = window.location.hash;

    // Allow deep linking to recover password form
    if (hash === '#recover') {
      toggleRecoverPasswordForm();
    }
  }

  /**
   *  Show/Hide recover password form
   */
  function toggleRecoverPasswordForm() {
    $('#RecoverPasswordForm').toggleClass('hide');
    $('#CustomerLoginForm').toggleClass('hide');
  }

  /**
   *  Show reset password success message
   */
  function resetPasswordSuccess() {
    var $formState = $('.reset-password-success');

    // check if reset password form was successfully submited.
    if (!$formState.length) {
      return;
    }

    // show success message
    $('#ResetSuccess').removeClass('hide');
  }
})();

/*================ Sections ================*/
/**
 * Product Template Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Product template.
 *
   * @namespace product
 */

 theme.Product = (function() {

  var selectors = {
    addToCart: '[data-add-to-cart]',
    addToCartText: '[data-add-to-cart-text]',
    comparePrice: '[data-compare-price]',
    comparePriceText: '[data-compare-text]',
    originalSelectorId: '[data-product-select]',
    priceWrapper: '[data-price-wrapper]',
    productFeaturedImage: '[data-product-featured-image]',
    productSlider: '[data-product-slider]',
    productThumbnails: '[data-product-thumbnails]',
    productJson: '[data-product-json]',
    productPrice: '[data-product-price]',
    productThumbs: '[data-product-single-thumbnail]',
    singleOptionSelector: '[data-single-option-selector]',
  };

  /**
   * Product section constructor. Runs on page load as well as Theme Editor
   * `section:load` events.
   * @param {string} container - selector for the section container DOM element
   */
  function Product(container) {
    var self = this;
    this.$container = $(container);

    // Stop parsing if we don't have the product json script tag when loading
    // section in the Theme Editor
    if (!$(selectors.productJson, this.$container).html()) {
      return;
    }

    var sectionId = this.$container.attr('data-section-id');
    this.productSingleObject = JSON.parse($(selectors.productJson, this.$container).html());

    var options = {
      $container: this.$container,
      enableHistoryState: this.$container.data('enable-history-state') || false,
      singleOptionSelector: selectors.singleOptionSelector,
      originalSelectorId: selectors.originalSelectorId,
      product: this.productSingleObject
    };

    this.settings = {};
    this.namespace = '.product';
    this.variants = new slate.Variants(options);
    this.$featuredImage = $(selectors.productFeaturedImage, this.$container);

    this.currentVariant   = this.variants.currentVariant;
    //const currentOptions  = this.getCurrentVariantOptions(this.currentVariant);

    // main product slider
    this.$slider = this.$container.find(selectors.productSlider);

    if(this.$slider.length){
      this.$slider.slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: false,
        fade: true,
        dots: true,
        asNavFor: selectors.productThumbnails,
        lazyLoad: 'ondemand',
        infinite: false
      });
    }

    this.$slider.slick("slickSetOption", "swipe", window.innerWidth < 1025);
    $(window).on('resize orientationchange', () => {
      self.$slider.slick("slickSetOption", "swipe", window.innerWidth < 1025);
      self.$slider.slick('resize');
    });

    // thumbnails slider
    this.$thumbnails = this.$container.find(selectors.productThumbnails);

    if(this.$thumbnails.children().length <= 8) {
      this.$thumbnails.closest('.product__gallery-wrap').addClass('no-transform')
    } else {
      this.$thumbnails.closest('.product__gallery-wrap').removeClass('no-transform')
    }

    if(this.$thumbnails.length){
      this.$thumbnails.on('init', function() {
        try {
          self.$thumbnails.slick("slickGoTo", 0, true);
        }
        catch(error) {
            setTimeout(function() {self.$thumbnails.trigger('init');}, 5);
            return;
        }

        self.updateProductSlider.bind(self)();
        self.$thumbnails.addClass('slick-loaded');
        self.$slider.addClass('slick-loaded');
      });
      this.$thumbnails.slick({
        slidesToShow: 8,
        prevArrow: '<button class="slick-prev slick-arrow--button"><svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="15px" height="16px" viewBox="0 0 15 16" enable-background="new 0 0 15 16" xml:space="preserve"><path stroke="#000000" stroke-width="0.1" d="M8.712,14.063L8.563,4.342l4.589,4.57l0.035,0.035l0.035-0.035l1.188-1.193 l0.035-0.036L14.41,7.648L7.697,0.963L7.662,0.928L7.626,0.963L0.942,7.676L0.907,7.711l0.036,0.036l1.192,1.188L2.171,8.97 l0.035-0.035l4.571-4.589l-0.002,9.697v0.021l0.015,0.015l0.933,0.931l0.036,0.035l0.035-0.036L8.697,14.1l0.016-0.015L8.712,14.063 z"/></svg></button>',
        nextArrow: '<button class="slick-next slick-arrow--button"><svg width="15" height="16" viewBox="0 0 15 16" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M6.65377 1.90635L6.78319 11.628L2.20393 7.04878L2.16857 7.01343L2.13322 7.04878L0.942672 8.23933L0.907317 8.27469L0.942672 8.31004L7.64131 15.0087L7.67667 15.044L7.71202 15.0087L14.4107 8.31004L14.446 8.27469L14.4107 8.23933L13.2201 7.04878L13.1848 7.01343L13.1494 7.04878L8.56879 11.6294L8.59075 1.93279L8.5908 1.91204L8.57614 1.89735L7.64484 0.964671L7.60948 0.929263L7.5741 0.964645L6.66841 1.87033L6.65349 1.88525L6.65377 1.90635Z" fill="black" stroke="black" stroke-width="0.1"/></svg></button>',
        asNavFor: selectors.productSlider,
        focusOnSelect: true,
        infinite: false,
        vertical: true,
        verticalSwiping: true,
        responsive: [{
          breakpoint: 1023,
          settings: {
            rows: 0,
            vertical: false,
            slidesToShow: 5,
            verticalSwiping: false,
            prevArrow: '<button class="slick-prev slick-arrow--button"><svg width="19" height="15" viewBox="0 0 19 15" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M17.0674 6.67574L4.3452 6.80555L8.92485 2.2259L8.96021 2.19055L8.92485 2.15519L7.7343 0.964645L7.69894 0.92929L7.66359 0.964645L0.964955 7.66329L0.929598 7.69864L0.964955 7.734L7.66359 14.4326L7.69894 14.468L7.7343 14.4326L8.92485 13.2421L8.96021 13.2067L8.92485 13.1714L4.34417 8.59069L17.0409 8.61273L17.0616 8.61276L17.0763 8.59811L18.009 7.66681L18.0444 7.63145L18.009 7.59607L17.1033 6.69038L17.0884 6.67553L17.0674 6.67574Z" fill="black" stroke="black" stroke-width="0.1"/></svg></button>',
            nextArrow: '<button class="slick-next slick-arrow--button"><svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="19px" height="15px" viewBox="0 0 19 15" enable-background="new 0 0 19 15" xml:space="preserve"><path stroke="#000000" stroke-width="0.1" d="M1.909,8.735l12.722-0.153l-4.57,4.588l-0.036,0.036l0.036,0.034l1.192,1.189 l0.035,0.035l0.036-0.036l6.686-6.711l0.035-0.036L18.01,7.647l-6.712-6.686l-0.034-0.035l-0.036,0.035l-1.188,1.193l-0.035,0.035 l0.035,0.035l4.59,4.573L1.932,6.798H1.912L1.896,6.814L0.966,7.746L0.93,7.782l0.037,0.035l0.907,0.904l0.016,0.015H1.909z"/></svg></button>'
          },
        }]
      });
    }

    this.$thumbnails.slick("slickSetOption", "swipe", window.innerWidth < 1025);
    $(window).on('resize orientationchange', () => {
      self.$thumbnails.slick("slickSetOption", "swipe", window.innerWidth < 1025);
    });

    this.$container.on('variantChange' + this.namespace, this.updateProductSlider.bind(this));
    this.$container.on('variantChange' + this.namespace, this.updateAddToCartState.bind(this));
    this.$container.on('variantPriceChange' + this.namespace, this.updateProductPrices.bind(this));

    if (this.$featuredImage.length > 0) {
      this.settings.imageSize = slate.Image.imageSize(this.$featuredImage.attr('src'));
      slate.Image.preload(this.productSingleObject.images, this.settings.imageSize);

      this.$container.on('variantImageChange' + this.namespace, this.updateProductImage.bind(this));
    }
  }

  Product.prototype = $.extend({}, Product.prototype, {

    /**
     * Updates the DOM state of the add to cart button
     *
     * @param {boolean} enabled - Decides whether cart is enabled or disabled
     * @param {string} text - Updates the text notification content of the cart
     */
    updateAddToCartState: function(evt) {
      var variant = evt.variant;
      var btnsNotify = $('.btn__product--notify');
      var btnsNotifyActive = $(`[data-variant-id=${variant.id}]`);
      var form = $('.pdp-form');

      if (variant) {
        $(selectors.priceWrapper, this.$container).removeClass('hide');
      } else {
        // $(selectors.addToCart, this.$container).prop('disabled', true);
        // $(selectors.addToCart, this.$container).addClass('hide');
        $(selectors.addToCartText, this.$container).html(theme.strings.unavailable);
        $(selectors.priceWrapper, this.$container).addClass('hide');
        return;
      }

      if (variant.available) {
        $(selectors.addToCart, this.$container).prop('disabled', false);
        $(selectors.addToCart, this.$container).removeClass('hide');
        $(selectors.addToCart, this.$container).css('opacity', '1');
        $(selectors.addToCartText, this.$container).html(theme.strings.addToCart);
        $('.payment-buttons__holder').removeClass('hide');
        btnsNotify.addClass('hide')

      } else {
        $(selectors.addToCart, this.$container).prop('disabled', true);
        $(selectors.addToCart, this.$container).css('opacity', '.5');
        $(selectors.addToCart, this.$container).removeClass('hide');
        $(selectors.addToCartText, this.$container).html(theme.strings.soldOut);


        $(btnsNotify).each(function(block) {
          $(this).addClass('hide');
        });

        if(btnsNotifyActive.length > 0) {
          $(btnsNotifyActive).removeClass('hide');
          $(selectors.addToCart, this.$container).addClass('hide');


          if(form.hasClass( "pdp-form--sold-out" )) {
            $('.page-with--product').find('.product-gallery__marquee span').text('Sold Out');
          } else {
            if(document.querySelector('.coming_soon-true')){
              $('.page-with--product').find('.product-gallery__marquee span').text('Coming Soon');
              $('.coming_soon-true').click(function(){
                $('button.wk-button-product.wk-add-product').click();
                $('.coming_soon-true span').text('Added to wishlist');
              })
            }else{
              $('.page-with--product').find('.product-gallery__marquee span').text('Out of Stock');
            }
          }

          $('.payment-buttons__holder').removeClass('hide');
        } else {
          $(btnsNotifyActive).addClass('hide');
          $('.payment-buttons__holder').addClass('hide');
        }



      }
    },

    /**
     * Updates the DOM with specified prices
     *
     * @param {string} productPrice - The current price of the product
     * @param {string} comparePrice - The original price of the product
     */
    updateProductPrices: function(evt) {
      var variant = evt.variant;
      var $comparePrice = $(selectors.comparePrice, this.$container);
      var $compareEls = $comparePrice.add(selectors.comparePriceText, this.$container);

      $(selectors.productPrice, this.$container)
        .html(slate.Currency.formatMoney(variant.price, theme.moneyFormat));

      if (variant.compare_at_price > variant.price) {
        $comparePrice.html(slate.Currency.formatMoney(variant.compare_at_price, theme.moneyFormat));
        $compareEls.removeClass('hide');
      } else {
        $comparePrice.html('');
        $compareEls.addClass('hide');
      }
    },


    /**
     * Updates the DOM with the specified image URL
     *
     * @param {string} src - Image src URL
     */
    updateProductImage: function(evt) {
      var variant = evt.variant;
      var sizedImgUrl = slate.Image.getSizedImageUrl(variant.featured_image.src, this.settings.imageSize);

      this.$featuredImage.attr('src', sizedImgUrl);
    },

    /**
     * Updates the DOM with the specified slides
     */
    // updateProductSlider: function(evt) {
    //   let variant = evt !== undefined ? evt.variant : this.currentVariant;
    //   let colorOptionIndex = this.productSingleObject.options.map(v => v.toLowerCase()).indexOf('color');
    //   let color = variant.options[colorOptionIndex];
    //   // this.$slider.slick('slickUnfilter');
    //   // let slider_has_color = $('.product__thumbnail-gallery [data-id="' + variant.id + '"]', self.$slider);
    //   this.$slider.slick('slickUnfilter');
    //   let slider_has_color = $('[data-color="'+ color +'"]', this.$slider);
    //   this.$slider.slick('slickFilter', function() {
    //     if (slider_has_color === undefined || slider_has_color.length === 0){
    //       return true;
    //     }
    //     return $('[data-color="'+ color +'"]', this).length === 1;
    //   })
    //   this.$slider.slick('resize');


    //   // slider_has_color.trigger('click');

    //   if (variant.available) {
    //     $('.product-gallery__marquee').addClass('hide');
    //     $('.js-product__gallery, .product__featured-image').removeClass('product--sold-out');
    //   } else {
    //     $('.product-gallery__marquee').removeClass('hide');
    //     $('.js-product__gallery, .product__featured-image').addClass('product--sold-out');
    //   }
    // },

    updateProductSlider: function(evt) {
      let variant = evt !== undefined ? evt.variant : this.currentVariant;
      let colorOptionIndex = this.productSingleObject.options.map(v => v.toLowerCase()).indexOf('color');
      let color = variant.options[colorOptionIndex];

      // let selected_color = $('.product__thumbnail-gallery [data-id="' + variant.id + '"]', self.$slider);
      // selected_color.trigger('click');

      this.$slider.slick('slickUnfilter');
      let slider_has_color = $('[data-color="' + color + '"]', self.$slider);
      let video = $('[data-color="all colors"]', self.$slider);

      this.$slider.slick('slickFilter', function () {
        if (slider_has_color === undefined || slider_has_color.length === 0){
          return true;
        }
        return $('[data-color="' + color + '"], [data-color="all colors"]', this).length === 1;
      });

      this.$slider.slick('resize');

      this.$thumbnails.slick('slickUnfilter');
      let thumbnails_has_color = $('[data-color="' + color + '"]', self.$thumbnails);
      this.$thumbnails.slick('slickFilter', function () {
        if (thumbnails_has_color === undefined || thumbnails_has_color.length === 0){
          return true;
        }
        return $('[data-color="' + color + '"], [data-color="all colors"]',  this).length === 1;
      });
      this.$thumbnails.slick('resize');

      var index = 0;
      $.each(this.$thumbnails.find('.slick-slide').not(".slick-cloned"), function (t, v) {
        $(v).attr("data-slick-index", index);
        index++;
      });

      const radioSelector = document.querySelector(`.variant-radio-selector[data-variant-id="${variant.id}"]`)
      const productGallery = document.querySelector('.product__gallery')
      const { isLimited } = radioSelector.dataset

      if (productGallery) {
        if (isLimited.includes('true')) {
          productGallery.classList.add('is-limited')
        } else {
          productGallery.classList.remove('is-limited')
        }
      }

      if (variant.available) {
        $('.product-gallery__marquee').addClass('hide');
        $('.js-product__gallery, .product__featured-image').removeClass('product--sold-out');
      } else {
        $('.product-gallery__marquee').removeClass('hide');
        $('.js-product__gallery, .product__featured-image').addClass('product--sold-out');
      }
    },

    /**
     * Event callback for Theme Editor `section:unload` event
     */
    onUnload: function() {
      this.$container.off(this.namespace);
    }
  });

  return Product;
})();


/***************** BLOCKS *****************/
;(function() {
  const popup = jQuery('.js-cookies_popup');
  const openedClass = 'opened';
  const bodyOpenedClass = 'cookies-popup-opened';
  const acceptBtn = popup.find('.js-cookies_close');
  const closeBtn = popup.find('.js-cookies_close-popup');
  const body = jQuery('body');

  acceptBtn.on('click', function(e) {
    e.preventDefault();
    jQuery.cookie('cookies_popup_disabled', '1', {path: '/'});
    hidePopup();
  });

  closeBtn.on('click', function(e) {
    e.preventDefault();
    jQuery.cookie('cookies_popup_disabled', '0', {path: '/'});
    hidePopup();
  });

  if (jQuery.cookie('cookies_popup_disabled') !== '1') {
    setTimeout(function() {
      if (popup.length) {
        showPopup();
      }
    }, popup.data('delay'));
  }

  function showPopup() {
    popup.addClass(openedClass);
    body.addClass(bodyOpenedClass);
  }

  function hidePopup() {
    popup.removeClass(openedClass);
    body.removeClass(bodyOpenedClass);
  }

}());



;(function() {
  const popup = jQuery('#newsletter_popup');
  const openedClass = 'opened';
  const bodyOpenedClass = 'newsletter-popup-opened';
  const control = jQuery('#newsletter-popup_control');
  const closeBtn = popup.find('.close');
  const body = jQuery('body');
  const delayDays = popup.data('again-delay');

  closeBtn.on('click touchend', function(e) {
    e.preventDefault();
    if (jQuery(this).hasClass('newsletter-popup__close')) {
      jQuery.cookie('newsletter_popup_disabled', '1', { expires: delayDays });
    }
    hidePopup();
  });

  if (+popup.data('delay') > 0 && jQuery.cookie('newsletter_popup_disabled') !== '1') {
    setTimeout(function() {
      if (popup.length) {
        showPopup();
        controlCookie();

        jQuery(document).on('click',function (e) {
          if(popup.hasClass(openedClass)) {
            // console.log('target', jQuery(e.target))
            // console.log('closest', jQuery(e.target).closest(popup))
            if (!jQuery(e.target).closest(popup).length) {
              hidePopup();
            }
          }
        });
      }
    }, popup.data('delay'));
  }

  function showPopup() {
    popup.addClass(openedClass);
    body.addClass(bodyOpenedClass);
  }

  function hidePopup() {
    popup.removeClass(openedClass);
    body.removeClass(bodyOpenedClass);

    if (popup.find('.newsletter-popup__thankyou-message').length) {
      jQuery.cookie('newsletter_popup_disabled', '1', { expires: delayDays });
    }
  }

  function controlCookie() {
    control.on('submit', function() {
      jQuery.cookie('newsletter_popup_disabled', '1', { expires: delayDays });
    });
  }
}());

/*================ Header Block ================*/
;(function () {

  jQuery('.shopify-section--header').stickyScrollBlock({
    setBoxHeight: false,
    activeClass: 'fixed-header',
    positionType: 'fixed',
    container: '.page-content',
    extraTop: function() {
      var totalHeight = 0;
      jQuery('0').each(function() {
        totalHeight += jQuery(this).outerHeight();
      });
      return totalHeight;
    }
  });

  jQuery('body').mobileNav({
    menuActiveClass: 'search-active',
    menuOpener: '.js-search__opener',
    hideOnClickOutside: true,
    menuDrop: '.header__search'
  });

  jQuery('body').mobileNav({
    menuActiveClass: 'navigation-active',
    menuOpener: '.js-navigation-opener',
    hideOnClickOutside: true,
    menuDrop: '.mobile-navigation__wrap'
  });


  jQuery('.sub-navigation__item').each(function(index) {
    let prevLink = jQuery('.sub-navigation__item')[index-1];
    if(!jQuery(this).hasClass('only-second-level') && jQuery(prevLink).hasClass('only-second-level')) {
      jQuery(prevLink).addClass('second-level-add-style');
    }
  });

  jQuery('.js-accordion').slideAccordion({
    opener: '>.js-opener-navigation__link',
    slider: '>.js-accordion-slide',
    animSpeed: 300
  });


  const body = jQuery('body');
  if (jQuery.cookie('cookies_first_visited') === '1') {
    body.removeClass('first-visited');
  } else {
    body.addClass('first-visited');
  }
  jQuery.cookie('cookies_first_visited', '1');

  window.unload = function() {
    jQuery.removeCookie('cookies_first_visited');
  };


  jQuery('.navigation__item--has-drop').on({
    mouseenter: function () {
      body.removeClass(`first-visited`);
    }
  });

  jQuery('.js-search__opener').on({
    click: function () {
      body.removeClass(`first-visited`);
      const input = jQuery('#search-form__input-Search');
      jQuery(input[0]).focus();
    }
  });

}());

/*================ Footer Block ================*/
;(function () {

  jQuery(".social-networks__link").on({
    mouseenter: function () {
      jQuery(`.social-networks__link`).addClass(`no-selected`);
      jQuery(this).removeClass(`no-selected`);
    },
    mouseleave: function () {
      jQuery(`.social-networks__link`).removeClass(`no-selected`)
    }
  });

}());

;(function () {
  jQuery('.general-form__row').addFocusClass({
    focusClass: 'input-focused',
    stayFocusOnFilled: true
  });

  jQuery('.js-validation').formValidation({
    errorClass: 'general-form__error',
    addClassToParent: '.general-form__row'
  });

  jQuery('.template-product .shopify-product-form').formValidation({
    errorClass: 'line-item__error',
    addClassToParent: '.line-item-property__field',
    errorFormClass: 'form__error'
  });

  jQuery("#create_customer #CreatePassword").passwordValidation({"confirmField": "#myConfirmPassword"}, function(element, valid, match, failedCases) {
    $("#errors").html("<pre>" + failedCases.join("\n") + "</pre>");
    if(valid) $(element).css("border-bottom","1px solid rgba(0, 0, 0, 0.5)");
    if(!valid) $(element).css("border-bottom","1px solid #eb5757");
  });

  jQuery(".account-form--recover #CustomerPassword").passwordValidation({"confirmField": "#myConfirmPassword"}, function(element, valid, match, failedCases) {
    $("#errors").html("<pre>" + failedCases.join("\n") + "</pre>");
    if(valid) $(element).css("border-bottom","1px solid rgba(0, 0, 0, 0.5)");
    if(!valid) $(element).css("border-bottom","1px solid #eb5757");
  });


  jQuery('.protected-password__link a').on('click', function() {
    $('.protected-password__login').removeClass('hide');
    $('.password-protected__main').addClass('hide');
  });

  const targetButtons = jQuery('.js-password');

  targetButtons.each(function() {
    const input = jQuery(this).find('.js-placeholder-input');
    const link = jQuery(this).find('.js-password-link');

    link.on('click', function() {
      if (input.attr('type') === 'password') {
        input.attr('type', 'text');
        link.addClass('shown');
      } else {
        input.attr('type', 'password');
        link.removeClass('shown');
      }
    });
  });


  jcf.setOptions('Select', {
    wrapNative: false,
  });
  jcf.replaceAll();
}());

;(function() {

  const players = Plyr.setup('.media-video');

  $('[data-fancybox]').fancybox({
    idleTime: false,
    buttons: [
      "close"
    ],
    clickSlide: false,
    btnTpl: {
      close:
        '<button data-fancybox-close class="fancybox-button fancybox-button--close" title="{{CLOSE}}">' +
        '<svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M1.25 1.25L20.75 20.75M20.75 1.25L1.25 20.75" stroke="black" stroke-width="1.625" stroke-linecap="round"/></svg>' +
        "</button>",
      arrowLeft:
        '<button data-fancybox-prev class="fancybox-button fancybox-button--arrow_left" title="{{PREV}}">' +
        '<div><svg width="40" height="15" viewBox="0 0 40 15" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M4.34394 6.80633L8.92436 2.2259L8.95972 2.19055L8.92436 2.15519L7.73381 0.964646L7.69846 0.929291L7.6631 0.964646L0.964466 7.66329L0.929112 7.69864L0.964466 7.734L7.6631 14.4326L7.69846 14.468L7.73381 14.4326L8.92436 13.2421L8.95972 13.2067L8.92436 13.1714L4.34354 8.59057L38.0404 8.61273L38.0611 8.61274L38.0758 8.59811L39.0085 7.66681L39.0439 7.63146L39.0085 7.59607L38.1028 6.69038L38.0881 6.67566L38.0673 6.67574L4.34394 6.80633Z" fill="black" stroke="black" stroke-width="0.1"/></svg></div>' +
        "</button>",
      arrowRight:
        '<button data-fancybox-next class="fancybox-button fancybox-button--arrow_right" title="{{NEXT}}">' +
        '<div><svg width="40" height="15" viewBox="0 0 40 15" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M35.6292 6.80633L31.0488 2.2259L31.0134 2.19055L31.0488 2.15519L32.2393 0.964646L32.2747 0.929291L32.31 0.964646L39.0087 7.66329L39.044 7.69864L39.0087 7.734L32.31 14.4326L32.2747 14.468L32.2393 14.4326L31.0488 13.2421L31.0134 13.2067L31.0488 13.1714L35.6296 8.59057L1.93271 8.61273L1.912 8.61274L1.89735 8.59811L0.964671 7.66681L0.929263 7.63146L0.964644 7.59607L1.87033 6.69038L1.88505 6.67566L1.90588 6.67574L35.6292 6.80633Z" fill="black" stroke="black" stroke-width="0.1"/></svg></div>' +
        "</button>"
    }
});

  // On before slide change
  jQuery('.js-product__gallery').on('beforeChange', function(event, slick, currentSlide, nextSlide){
    let slide = jQuery(`.product__gallery [data-slick-index=${currentSlide}]`);
    let button = jQuery(slide[0]).find('.plyr__control--overlaid');
    if(button.length > 0) {
      if(jQuery(button[0]).hasClass('plyr__control--pressed')) {
        jQuery(button[0]).trigger('click');
      }
    }
  });

  jQuery('.js-product-tabset').tabset({
    addToParent: true,
    defaultTab: true
  });

  // jQuery('.product__information--holder').stickyScrollBlock({
  //   setBoxHeight: true,
  //   activeClass: 'information-wrap--fixed',
  //   positionType: 'fixed',
  //   extraTop: -50,
  //   showAfterScrolled: true
  // });
}());

;(function () {
  var slider = $('.js-drops-banner-gallery').slick({
    slidesToScroll: 1,
    rows: 0,
    dots: true,
    dotsClass: 'slick-dots',
    prevArrow: `<button class="slick-prev">
    <svg width="40" height="15" viewBox="0 0 40 15" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M4.34412 6.80633L8.92455 2.2259L8.9599 2.19055L8.92455 2.15519L7.73399 0.964646L7.69864 0.929291L7.66328 0.964646L0.964649 7.66329L0.929295 7.69864L0.964649 7.734L7.66328 14.4326L7.69864 14.468L7.73399 14.4326L8.92455 13.2421L8.9599 13.2067L8.92455 13.1714L4.34373 8.59057L38.0406 8.61273L38.0613 8.61274L38.076 8.59811L39.0087 7.66681L39.0441 7.63146L39.0087 7.59607L38.103 6.69038L38.0883 6.67566L38.0674 6.67574L4.34412 6.80633Z" fill="currentColor" stroke="currentColor" stroke-width="0.1"/>
    </svg>
    </button>`,
    nextArrow: `<button class="slick-next">
    <svg width="40" height="15" viewBox="0 0 40 15" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M35.6293 6.80633L31.0488 2.2259L31.0135 2.19055L31.0488 2.15519L32.2394 0.964646L32.2747 0.929291L32.3101 0.964646L39.0087 7.66329L39.0441 7.69864L39.0087 7.734L32.3101 14.4326L32.2747 14.468L32.2394 14.4326L31.0488 13.2421L31.0135 13.2067L31.0488 13.1714L35.6297 8.59057L1.93277 8.61273L1.91206 8.61274L1.89741 8.59811L0.964732 7.66681L0.929324 7.63146L0.964705 7.59607L1.87039 6.69038L1.88512 6.67566L1.90594 6.67574L35.6293 6.80633Z" fill="currentColor" stroke="currentColor" stroke-width="0.1"/>
    </svg>
    </button>`,
    speed: 800,
    pauseOnHover: false
  });

  new ResizeSensor(jQuery('.main-content'), function(){ 
    let mainContainerWidth = $('.main-content').outerWidth();
    $('.drops-banner-gallery__slide').width(mainContainerWidth);
    slider.slick('setPosition');
  });
}());
; (function () {
  // Hero gallery
  var slider = $('.js-hero-gallery').slick({
    slidesToScroll: 1,
    rows: 0,
    dots: true,
    arrows: false,
    dotsClass: 'slick-dots',
    speed: 800,
    pauseOnHover: true,
    autoplay: true,
    autoplaySpeed: 5000,
  });

  new ResizeSensor(jQuery('.hero'), function(){
    slider.slick('setPosition');
  });

  // Bg video
  $('.bg-video').each( function() {
    jQuery(this).backgroundVideo({
      activeClass: 'video-active'
    });
  })
  $('.vimeo-bg-player').each( function() {
    $(function() {
      var iframe = $(this)[0];
      var player = $f(iframe);
      player.addEvent('ready', function() {
          player.api('setVolume', 0);
      });
      // Call the API when a button is pressed
      $('button').bind('mouseover', function() {
          player.api($(this).text().toLowerCase());
      });
    });
  })

  $('.vimeo-play').hover(function(){
      $('.vimeo-play').addClass("d-none");
  });

  $( window ).resize(function() {
    document.documentElement.style.setProperty('--video-holder-height', $('.bg-video-holder').css('height'));
    document.documentElement.style.setProperty('--video-height', $('.hero-gallery__slide ').css('height'));
    document.documentElement.style.setProperty('--video-height-wide-banner', $('.full-width-banner ').css('height'));
    document.documentElement.style.setProperty('--featured-title-height', $('.featured-collection__heading ').css('height'));
  });
  setTimeout(function() {
  document.documentElement.style.setProperty('--video-holder-height', $('.bg-video-holder').css('height'));
  document.documentElement.style.setProperty('--video-height', $('.hero-gallery__slide ').css('height'));
  document.documentElement.style.setProperty('--video-height-wide-banner', $('.full-width-banner ').css('height'));
  document.documentElement.style.setProperty('--featured-title-height', $('.featured-collection__heading ').css('height'));
  }, 100);


  // Ticker
  $('.js-marquee').each( function() {
    const marquee = $(this);
    marquee.css({ "overflow": "hidden", "width": "100%" });
    marquee.wrapInner("<span>");
    marquee.find("span").css({ "width": "auto", "display": "block", "text-align": "center" });
    marquee.append(marquee.find("span").clone());
    marquee.append(marquee.find("span").clone());
    marquee.append(marquee.find("span").clone());
    marquee.append(marquee.find("span").clone());
    marquee.wrapInner("<div>");
    marquee.find("div").css("width", "100%");
    var reset = function () {
      $(this).css("margin-left", "0%");
      $(this).animate({ "margin-left": "-50%" }, 20000, 'linear', reset);
    };
    reset.call(marquee.find("div"));
  })

  // countdown timer
  function countdownMarkup(element, dString, hString, mString, sString) {
    var timer = $(element);
    var countTo
    var countToESTtime
    try {
      countTo = timer.data('count-to')
      const [date, time] = timer.data('count-to').split(' ')
      let [hours, minutes] = time.split(':')
      hours = +hours
      minutes = +minutes
      hours = (hours + 4) % 24
      if (`${hours}`.length < 2) hours = `0${hours}`
      if (`${minutes}`.length < 2) minutes = `0${minutes}`
      var countToESTtimeRaw = moment.tz(`${date} ${hours}:${minutes}`, "America/New_York")
      countToESTtime = countToESTtimeRaw.toDate();
    } catch (ex) {
      console.error(ex)
    }
    timer
      .countdown(countToESTtime || "2020/09/28", function (event) {
        if (event.type === 'update') {
          var $this = $(this).html(event.strftime(''
            + `<div class="countdown-timer__item">
                  <div class="countdown-timer__subitem">
                    <div class="countdown-timer__time dTime1">%D</div>
                    <div class="countdown-timer__time dTime2">%D</div>
                    <div class="countdown-timer__dot">:</div>
                  </div>
                  <div class="countdown-timer__time-label">${dString}</div>
                </div>`
            + `<div class="countdown-timer__item">
                  <div class="countdown-timer__subitem">
                    <div class="countdown-timer__time hTime1">%H</div>
                    <div class="countdown-timer__time hTime2">%H</div>
                    <div class="countdown-timer__dot">:</div>
                  </div>
                  <div class="countdown-timer__time-label">${hString}</div>
                </div>`
            + `<div class="countdown-timer__item">
                  <div class="countdown-timer__subitem">
                    <div class="countdown-timer__time mTime1">%M</div>
                    <div class="countdown-timer__time mTime2">%M</div>
                    <div class="countdown-timer__dot">:</div>
                  </div>
                  <div class="countdown-timer__time-label">${mString}</div>
                </div>`
            + `<div class="countdown-timer__item">
                  <div class="countdown-timer__subitem">
                    <div class="countdown-timer__time sTime1">%S</div>
                    <div class="countdown-timer__time sTime2">%S</div>
                  </div>
                <div class="countdown-timer__time-label">${sString}</div>
              </div>`));
              
          let dText1 = $this.find('.dTime1').text();
          $this.find('.dTime1').text(dText1.charAt(0));
          $this.find('.dTime2').text(dText1.charAt(1));

          let hText1 = $this.find('.hTime1').text();
          $this.find('.hTime1').text(hText1.charAt(0));
          $this.find('.hTime2').text(hText1.charAt(1));

          let mText1 = $this.find('.mTime1').text();
          $this.find('.mTime1').text(mText1.charAt(0));
          $this.find('.mTime2').text(mText1.charAt(1));

          let sText1 = $this.find('.sTime1').text();
          $this.find('.sTime1').text(sText1.charAt(0));
          $this.find('.sTime2').text(sText1.charAt(1));

        } else if (event.type === 'finish') {
          $('.countdown-timer').hide();
        }
      })
  }

  function countdownTimer(element) {
    countdownMarkup(element, 'Days', 'Hours', 'Min', 'Sec'),
      function () {
        $(element).countdown('remove');
      }
  }

  $('.countdown-timer__time-box').each( function() {
    countdownTimer($(this));
  })

  // jQuery('body').mobileNav({
  //   menuActiveClass: 'newsletter-popup-opened',
  //   menuOpener: '.js-newsletter-popup-opener',
  //   hideOnClickOutside: true,
  //   menuDrop: '.newsletter-popup'
  // });
  const newsletterPopupOpeners = document.querySelectorAll('.js-newsletter-popup-opener')
  const newsletterPopupActiveClass = 'newsletter-popup-opened'
  const newsletterPopupClosers = document.querySelectorAll('.newsletter-popup-closer')
  function showPopup() {
    document.querySelectorAll('html, body').forEach(el => el.classList.add(newsletterPopupActiveClass))
  }
  function hidePopup() {
    document.querySelectorAll('html, body').forEach(el => el.classList.remove(newsletterPopupActiveClass))
  }

  newsletterPopupOpeners.forEach(button => {
    button.addEventListener('click', (e) => {
      e.preventDefault()
      showPopup()
    })
  })
  newsletterPopupClosers.forEach(button => {
    button.addEventListener('click', () => {
      hidePopup()
    })
  })
}());

;(function() {
  const miniCartContainer = jQuery('[data-mini-cart-container]');
  const miniCartTrigger = jQuery('[data-mini-cart-trigger]');
  const miniCartActive = 'mini-cart--shown';
  const miniCartParent = jQuery('[data-mini-cart]');
  const cartCount = jQuery('[data-cart-count]');
  const cartTotal = jQuery('[data-cart-total]');
  const cartFull = jQuery('[data-full-cart-content]');
  const cartEmpty = jQuery('[data-empty-cart-content]');

  jQuery(document).on('cart.requestComplete', function(event, cart) {
    cartCount.html(cart.item_count);
    cartTotal.html(Shopify.formatMoney(cart.items_subtotal_price));
    checkVariantLimit();

    try {
      window.KOSMApp.updatePurchaseAmount();
    } catch (ex) { console.error(ex) }

    if (!miniCartParent.hasClass(miniCartActive)) {
      miniCartParent.addClass(miniCartActive);
    }

    if (cart.item_count === 0) {
      cartCount.addClass('hide');
      cartFull.addClass('hide');
      cartEmpty.removeClass('hide');
      miniCartContainer.addClass('mini-cart__empty-holder');
    } else {
      cartCount.removeClass('hide');
      cartFull.removeClass('hide');
      cartEmpty.addClass('hide');
      miniCartContainer.removeClass('mini-cart__empty-holder');
    }
  });

  jQuery(document).on('input', '[data-variant]', function() {
    var $this = jQuery(this);
    CartJS.updateItem(Number.parseInt($this.attr('data-variant')), Number.parseInt($this.val()));
  });

  function addMiniCartTrigger(e) {
    e.preventDefault();
    miniCartParent.toggleClass(miniCartActive);
  }

  //Add product.json.liquid
  function checkVariantLimit() {


    const cartItemParent = jQuery('[data-minicart-item]');

    if(cartItemParent.length < 1){return};

    cartItemParent.each(function() {
      const item = jQuery(this);
      const cartItem = item.find('[data-compare-price]');
      const cartItemPrice = item.find('[data-price]').attr('data-minicart-price');
      const cartItemFullUrl = cartItem.attr('data');
      const cartItemUrl = cartItemFullUrl && cartItemFullUrl.split('?')[0];
      const cartItemVariant = cartItemFullUrl && cartItemFullUrl.split('?')[1].split('=')[1];
      const cartItemQty = item.find('[data-item-qty]').val();
      const cartItemBtnPlus = item.find('[data-qty-number-plus]');
      const cartItemMessage = item.find('[data-limit-message]');

      jQuery.getJSON(cartItemUrl + '.js', function(product) {
        if(product.url !== cartItemUrl){return};
        cartItem.addClass('hide');

        jQuery(product.variants).each(function() {

          if(this.id == cartItemVariant && cartItemPrice < this.compare_at_price) {
            cartItem.html(Shopify.formatMoney(this.compare_at_price));
            cartItem.removeClass('hide');
          }

          if(this.id == cartItemVariant && cartItemPrice == 0 ) {
            item.addClass('free-product');
          }


          if(this.id == cartItemVariant) {
            fetch(`${cartItemUrl}?view=json`, {
              redirect: 'follow',
              credentials: 'include'
            }).then((response) => {
              response.json().then(function(parsedJson) {

                jQuery(parsedJson.option).each(function() {
                  let variant = Number.parseInt(cartItemVariant);
                  if(this[variant]) {
                    if(this[variant] == cartItemQty) {
                      cartItemMessage.removeClass('hide');
                      cartItemBtnPlus.addClass('btn-disabled');
                    } else {
                      cartItemMessage.addClass('hide');
                      cartItemBtnPlus.removeClass('btn-disabled');
                    }
                  }
                });
              })
            });
          }
        });
      });
    });
  }

  miniCartTrigger.click(addMiniCartTrigger);
  setTimeout(checkVariantLimit, 1000);

}());

;(function() {
  ResponsiveHelper.addRange({
    '1024..': {
      on: function() {
        jQuery('.js-one-collection-gallery').slick({
          slidesToScroll: 1,
          rows: 0,
          infinite: false,
          slidesToShow: 4,
          prevArrow: `<button class="slick-prev"><svg width="40" height="15" viewBox="0 0 40 15" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M4.34443 6.80633L8.92485 2.2259L8.96021 2.19055L8.92485 2.15519L7.7343 0.964646L7.69894 0.929291L7.66359 0.964646L0.964955 7.66329L0.9296 7.69864L0.964955 7.734L7.66359 14.4326L7.69894 14.468L7.7343 14.4326L8.92485 13.2421L8.96021 13.2067L8.92485 13.1714L4.34403 8.59057L38.0409 8.61273L38.0616 8.61274L38.0763 8.59811L39.009 7.66681L39.0444 7.63146L39.009 7.59607L38.1033 6.69038L38.0886 6.67566L38.0678 6.67574L4.34443 6.80633Z" fill="black" stroke="black" stroke-width="0.1"/>
</svg></button>`,
          nextArrow: `<button class="slick-next"><svg width="40" height="15" viewBox="0 0 40 15" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M35.6292 6.80633L31.0488 2.2259L31.0134 2.19055L31.0488 2.15519L32.2393 0.964646L32.2747 0.929291L32.31 0.964646L39.0087 7.66329L39.044 7.69864L39.0087 7.734L32.31 14.4326L32.2747 14.468L32.2393 14.4326L31.0488 13.2421L31.0134 13.2067L31.0488 13.1714L35.6296 8.59057L1.93271 8.61273L1.912 8.61274L1.89735 8.59811L0.964671 7.66681L0.929263 7.63146L0.964644 7.59607L1.87033 6.69038L1.88505 6.67566L1.90588 6.67574L35.6292 6.80633Z" fill="black" stroke="black" stroke-width="0.1"/>
</svg></button>`,
          responsive: [{
            breakpoint: 1023,
            settings: {
              slidesToShow: 3
            }
          }]
        });
      },
      off: function() {
        jQuery('.js-one-collection-gallery').slick('destroy');
      }
    }
  });

  // jQuery('a.js-has-tooltip[title]').hoverTooltip({
  //   positionTypeX: 'center',
  //   positionTypeY: 'top',
  //   tooltipStructure: '<div class="hover-tooltip"><div class="tooltip-text js-marquee-text"></div></div>'
  // });


  const swatchList = document.querySelectorAll('[data-variant-image]');
  if(!swatchList) {
    return;
  }

  swatchList.forEach((swatch) => {
    swatch.addEventListener('click', function(){

      const parent = this.closest('.featured-product');
      if(parent) {

        const variantId = this.getAttribute('data-variant-image');

        const images = parent.querySelectorAll('.featured-product__image');

        const swatchElements = parent.querySelectorAll('.swatch-element');

        const variantPrices = parent.querySelectorAll('.js-featured-product__price');

        if(images.length < 2) {
          return;
        }

        images.forEach((image) => {
          image.classList.add('hide');
          const imageVariant = image.getAttribute('data-value');

          if(variantId == imageVariant) {
            image.classList.remove('hide');
          }
        })

        swatchElements.forEach((element) => {

          element.classList.remove('hover');
          this.closest('.swatch-element').classList.add('hover');

        })

        variantPrices.forEach((price) => {
          price.classList.add('hide');
          const priceVariant = price.getAttribute('data-variant-quantity');

          if(variantId == priceVariant) {
            price.classList.remove('hide');
          }
        })
      }
    });
  })


}());

jQuery('[data-review-collection]').slick({
  slidesToScroll: 1,
  rows: 0,
  infinite: false,
  slidesToShow: 4,
  prevArrow: `<button class="slick-prev"><svg width="40" height="15" viewBox="0 0 40 15" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M4.34443 6.80633L8.92485 2.2259L8.96021 2.19055L8.92485 2.15519L7.7343 0.964646L7.69894 0.929291L7.66359 0.964646L0.964955 7.66329L0.9296 7.69864L0.964955 7.734L7.66359 14.4326L7.69894 14.468L7.7343 14.4326L8.92485 13.2421L8.96021 13.2067L8.92485 13.1714L4.34403 8.59057L38.0409 8.61273L38.0616 8.61274L38.0763 8.59811L39.009 7.66681L39.0444 7.63146L39.009 7.59607L38.1033 6.69038L38.0886 6.67566L38.0678 6.67574L4.34443 6.80633Z" fill="black" stroke="black" stroke-width="0.1"/>
</svg></button>`,
  nextArrow: `<button class="slick-next"><svg width="40" height="15" viewBox="0 0 40 15" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M35.6292 6.80633L31.0488 2.2259L31.0134 2.19055L31.0488 2.15519L32.2393 0.964646L32.2747 0.929291L32.31 0.964646L39.0087 7.66329L39.044 7.69864L39.0087 7.734L32.31 14.4326L32.2747 14.468L32.2393 14.4326L31.0488 13.2421L31.0134 13.2067L31.0488 13.1714L35.6296 8.59057L1.93271 8.61273L1.912 8.61274L1.89735 8.59811L0.964671 7.66681L0.929263 7.63146L0.964644 7.59607L1.87033 6.69038L1.88505 6.67566L1.90588 6.67574L35.6292 6.80633Z" fill="black" stroke="black" stroke-width="0.1"/>
</svg></button>`,
  responsive: [{
    breakpoint: 1023,
    settings: {
      slidesToShow: 1,
      arrows: true
    }
  }]
});

; (function () {
  const $btnOpen = $('.js-slider-btn');
  const $btnClose = $('.js-slider-btn-destroy');
  const $btnOpenClose = $('.js-slider-btn, .js-slider-btn-destroy');
  const $wrapper = $('.js-slider-wrapper');
  const openClass = 'js-slide-open';

  $btnOpen.on('click', function (e) {
    e.preventDefault();
    const $btn = $(this);
    const $slider = $('#' + $btn.data('slider'));
    const btnHasClass = $btn.hasClass('active');

    $wrapper.each(function () {
      $(this).removeClass(openClass);
    });

    if (btnHasClass) {
      $btn.removeClass('active');
      return;
    }

    $btnOpen.each(function () {
      $(this).removeClass('active');
    });

    $btn.toggleClass('active');
    if ($btn.hasClass('active')) {
      $slider.closest($wrapper).addClass(openClass);
    } else {
      $slider.closest($wrapper).removeClass(openClass);
    }
  });

  $btnClose.on('click', function (e) {
    e.preventDefault();
    const $btn = $(this);
    const $slider = $('#' + $btn.data('slider'));
    const $wrapper = $btn.closest(".js-slider-wrapper");
    $wrapper.closest('.js-slider-wrapper').removeClass(openClass);
    $btnOpen.removeClass('active');
  });

  function clickOutsideHandler(e) {
    // if need close popup on click outside
    // const { target } = e;
    // const isSlider = $(target).hasClass('js-slider-wrapper') ||
    //   $(target).closest($btnOpen).length ||
    //   $(target).closest($wrapper).length;

    // if (isSlider) {
    //   return
    // }

    // $wrapper.each(function () {
    //   $(this).removeClass(openClass);
    // });

    // $btnOpen.each(function () {
    //   $(this).removeClass('active');
    // });
    instance.destroy();
    instance.init();
  }

  document.addEventListener('click', clickOutsideHandler);

  // BG video
  jQuery('[data-video]').bgVideo();

  $( window ).resize(function() {
    document.documentElement.style.setProperty('--blog-title-height', $('.blog__title ').css('height'));
  });
  document.documentElement.style.setProperty('--blog-title-height', $('.blog__title ').css('height'));

  // Parallax
  const parallax = document.getElementsByClassName('js-title-parallax');

  const instance = new simpleParallax(parallax, {
    delay: 1.5,
    transition: 'cubic-bezier(0,.92,.82,.86)',
    overflow: true,
    orientation: 'down',
    scale: 5,
    maxTransition: 160
  });

  $btnOpenClose.on('click', function (e) {
    e.preventDefault();
    instance.destroy();
    instance.init();
  });

  // Anchor link
  new SmoothScroll({
    anchorLinks: '.js-anchor-link',
    activeClasses: 'active',
    wheelBehavior: 'none',
    extraOffset: $('.header').height() || 300,
    animDuration: 800,
  });
}());


/*================ PLP ================*/
;(function () {

  jQuery('body').mobileNav({
    menuActiveClass: 'filter-active',
    menuOpener: '.js-filter-opener',
    hideOnClickOutside: true,
    menuDrop: '.boost-pfs-filter-wrapper .boost-pfs-filter-left-col'
  });
}());

; (function () {
  jQuery('body').mobileNav({
    menuActiveClass: 'newsletter-popup-opened',
    menuOpener: '.js-newsletter-password-popup-opener',
    hideOnClickOutside: true,
    menuDrop: '.newsletter-popup--alt'
  });

  $('.js-newsletter-password-popup-closer').on('click', function (e) {
    $('body').removeClass('newsletter-popup-opened')
  });
}());

if(jQuery('body').hasClass('template-cart')) {
  Shopify.Cart.ShippingCalculator.show( {
    submitButton: theme.strings.shippingCalcSubmitButton,
    submitButtonDisabled: theme.strings.shippingCalcSubmitButtonDisabled,
    customerIsLoggedIn: theme.strings.shippingCalcCustomerIsLoggedIn,
    moneyFormat: theme.strings.shippingCalcMoneyFormat
  } );
}


;(function () {

  const btnReset = jQuery('.search-form__reset');
  if(btnReset) {
    jQuery(btnReset).on('click', function (e) {
      e.preventDefault();
      const input = jQuery(btnReset).parent().find('input#search');
      jQuery(input[0]).val('').focus();
    });
  }

}());



$(document).ready(function() {
  var sections = new slate.Sections();
  sections.register('product', theme.Product);

  // Common a11y fixes
  slate.a11y.pageLinkFocus($(window.location.hash));

  $('.in-page-link').on('click', function(evt) {
    slate.a11y.pageLinkFocus($(evt.currentTarget.hash));
  });

  // Target tables to make them scrollable
  var tableSelectors = '.rte table';

  slate.rte.wrapTable({
    $tables: $(tableSelectors),
    tableWrapperClass: 'rte__table-wrapper',
  });

  // Target iframes to make them responsive
  var iframeSelectors =
    '.rte iframe[src*="youtube.com/embed"],' +
    '.rte iframe[src*="player.vimeo"]';

  slate.rte.wrapIframe({
    $iframes: $(iframeSelectors),
    iframeWrapperClass: 'rte__video-wrapper'
  });

  // Apply a specific class to the html element for browser support of cookies.
  if (slate.cart.cookiesEnabled()) {
    document.documentElement.className = document.documentElement.className.replace('supports-no-cookies', 'supports-cookies');
  }
});

$('ol.product-accordian-title').click(function(){

  if($(this).hasClass('active-open')){

    $('.active-open').removeClass('active-open')
    $('.accordian-open').slideUp().removeClass('accordian-open');

  }else{

    $('.active-open').removeClass('active-open')
    
    $(this).addClass('active-open');
    
    $('.accordian-open').slideUp().removeClass('accordian-open');
    
    $(this).next().addClass('accordian-open').slideDown();

  }
  
  })

const announcementBar = document.querySelector('.announcement-bar')
const pageContent = document.querySelector('.page-content')
if (announcementBar && pageContent) {
  pageContent.classList.add('announcement-is-enabled')
}

let count;
let cartArray = [];
let newCartArray = [];

$(document).on('cart.requestStarted', function(event, cart) {
  cartArray = [];
  newCartArray = [];
  count = cart.item_count;
  $(cart.items).each(function(){
    cartArray.push(this.variant_id+' '+this.quantity+' '+this.final_price)
  });
});

$(document).on('cart.requestComplete', function(event, cart) {
  if( count < cart.item_count ){
    $(cart.items).each(function(){
      newCartArray.push(this.variant_id+' '+this.quantity+' '+this.final_price)
    });

    // console.log(cartArray)
    // console.log(newCartArray)

    var difference = newCartArray.filter(x => cartArray.indexOf(x) === -1);
    var diff = difference[0].split(" ");
    var qtyDiff;
    var DYqty;

    var productId = diff[0];
    var productQty = parseInt(diff[1]);
    var productPrice = (diff[2] / 100);

    $(cartArray).each(function(k, v){
      if(cartArray[k].includes(productId)){
        qtyDiff = cartArray[k].split(" ");
        qtyDiff = parseInt(qtyDiff[1])
      }
    })

    if(qtyDiff == null){
      DYqty = 1;
    }else{
      DYqty = productQty - qtyDiff
      if(DYqty <= 0){
        DYqty = 1;
      }
    }

    var DYCartData = [];

    for(var i=0; i < cart.items.length; i++){
      var forObj = { 
        productId: cart.items[i].id,
        quantity: cart.items[i].quantity,
        itemPrice: (cart.items[i].final_price/100).toFixed(2)
      }
      DYCartData.push(forObj);
    }

    DY.API("event", {
        name: "Add to Cart",
        properties: {
          dyType: "add-to-cart-v1",
          value: (productPrice * DYqty),
          currency: "USD",
          productId: productId,
          quantity: DYqty,
          cart: DYCartData,
          itemPrice: productPrice
        }
    });

    cartArray = [];
    newCartArray = [];
  }
});

function disableConsole() {
  console.log = function(...args) {}
  console.error = function(...args) {}
  console.info = function(...args) {}
  localStorage.setItem('consoleIsDisabled', 'true')
}

function enableConsole() {
  localStorage.setItem('consoleIsDisabled', 'false')
  location.href = location.href
}

console.disable = function() { disableConsole() }
console.enable = function() { enableConsole() }

const consoleIsDisabled = localStorage.getItem('consoleIsDisabled')
if (consoleIsDisabled === 'true') {
  disableConsole()
}

const winterDreamsLookbookArticle = !!document.querySelector('.article--winter-2021-dreams-lookbook')
if (winterDreamsLookbookArticle) {
  const productLinksSelector = '.article--winter-2021-dreams-lookbook .p-product a'
  const productLinks = document.querySelectorAll(productLinksSelector)
  productLinks.forEach(pl => {
    pl.setAttribute('title', 'Shop it')
  })
  // jQuery(productLinksSelector).hoverTooltip({
  //   positionTypeX: 'center',
  //   positionTypeY: 'top',
  //   tooltipStructure: '<div class="hover-tooltip"><div class="tooltip-text js-marquee-text"></div></div>'
  // });
}

function parseFaqContent(container) {
  container.classList.add('faq__content')
  const contentElements = [...container.querySelectorAll('.rte > *')]
  let parsedContent = ''
  contentElements.forEach((ce, ceIndex) => {
    const isLastElement = ceIndex === contentElements.length - 1
    const startDivs = (parsedContent.match(/<div/g) || []).length;
    const endDivs = (parsedContent.match(/<\/div>/g) || []).length;
    const divIsNotEnded = startDivs > endDivs
    const text = ce.innerText.trim()

    if (!text) {
      parsedContent += `${divIsNotEnded ? '</div>' : ''}${ce.outerHTML}`
    } else {
      switch (ce.tagName) {
        case 'H4': {
          parsedContent += `${divIsNotEnded ? '</div>' : ''}<div class="faq__item">${ce.outerHTML}`
          break
        }
        case 'H2': {
          if (ceIndex === 0) {
            parsedContent += `${ce.outerHTML}`
          } else {
            parsedContent += `${divIsNotEnded ? '</div>' : ''}${ce.outerHTML}`
          }
          break
        }
        case 'P': {
          parsedContent += `${ce.outerHTML}`
          break
        }
        default: {
          parsedContent += `${ce.outerHTML}`
        }
      }
    }

    if (isLastElement && divIsNotEnded) parsedContent += `</div>`
  })
  const contentContainer = container.querySelector('.rte')
  contentContainer.innerHTML = parsedContent
  contentContainer.querySelectorAll('.faq__item').forEach(item => {
    const question = item.querySelector('h4')
    question.addEventListener('click', () => {
      item.classList.toggle('faq__item--active')
    })
  })
}

const isFaqPage = !!document.querySelector('body#faq')
if (isFaqPage) {
  try {
    parseFaqContent(document.querySelector('.main-content'))
  } catch (ex) {
    console.error(ex)
  }
}

if(window.innerWidth >= 1024 && $('div#shopify-section-product-template').length){

  function stickySectionsNav() {
    const nav = document.querySelector(".product__thumbnail-gallery-desktop");
    const stickyHeaderHeight = document.querySelector("header.header").offsetHeight;

    const sections = document.querySelectorAll(".product__gallery-item-desktop");
    const navLi = nav.querySelectorAll("li a");
    let current = "";

    sections.forEach((section) => {
      const sectionTop = section.offsetTop;
      if (window.scrollY >= sectionTop - stickyHeaderHeight) {
        current = section.getAttribute("id");
      }
    });

      console.log(current)
    navLi.forEach((item) => {
      item.classList.remove("active");
      const href = item.getAttribute("href");

      if (href === "#" + current) {
        item.classList.add("active");
      }
    });
  }

  window.addEventListener("scroll", function () {
    stickySectionsNav();
  });

}